import axios from "./Axios";
import { success, error } from "./ResponseHandler";
import GLOBAL from "../global";

const vaApi = process.env.REACT_APP_VA_API_URL;

class AcademicCitationService {
    async getAcademicCitation(testId) {
        try {
            const response = await axios.post(`${vaApi}/api/Report/AcademicCitation`, {
                Tenant: GLOBAL.TENANT,
                TestId: testId
            });

            return success(response);
        } catch (e) {
            return error(e);
        }
    }
}

export default new AcademicCitationService();
